import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, isFirebaseConfigured } from '../firebase';

const ProtectedRoute = ({ children }) => {
  const [authState, setAuthState] = useState({
    checking: true,
    allowed: false
  });

  useEffect(() => {
    if (!isFirebaseConfigured || !auth) {
      setAuthState({ checking: false, allowed: false });
      return;
    }

    const allowedAdminUid = process.env.REACT_APP_ADMIN_UID || 'Zck0u0cXLSYAIZrvXmCjINxRzU03';
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      const isAllowed = Boolean(user && user.uid === allowedAdminUid);
      setAuthState({ checking: false, allowed: isAllowed });
    });

    return () => unsubscribe();
  }, []);

  if (authState.checking) {
    return <div className="admin-dashboard-loading">Checking authentication...</div>;
  }

  if (!authState.allowed) {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
};

export default ProtectedRoute;
